import { useContext, useLayoutEffect, useState} from "react";
import {GlobalContext} from "../../../Context/GlobalContext/AppContext";
import BaseModal from "../BaseModal";
import Button from "../../atoms/Button";
import './styles.scss';
import {tipoDocRelQuantity} from "../../../pools/filterPool";
import FormTitle from "../../organisms/Form/FormTitle";
import {downloadExcel} from "react-export-table-to-excel";
import { CSVLink } from "react-csv";

const QuantificationModal = () => {
  const { quantidadeModal, setQuantidadeModal, documentsAll, setResponseMsg } = useContext(GlobalContext);
  const [tipo, setTipo] = useState({tipoDoc: 1});
  const [startDate] = useState(new Date());
  const [endDate] = useState(new Date());
  const [body, setBody] = useState([])
    const header = [
    "Tipo Norma",
    "Código/Numero",
    "Titulo da norma",
    "Descrição",
    "Ordem",
    "Tag",
    "Versão",
    "Downloads",
    "Data de cadastro",
    "Classficação",
    "Ativo?"
  ];

    const headers = [
    { label: "Tipo norma", key: "TipoDoc" },
    { label: "Código/Numero", key: "ID" },
    { label: "Titulo da norma", key: "Titulo" },
    { label: "Descrição", key: "Descricao" },
    { label: "Ordem", key: "Ordem" },
    { label: "Tag", key: "Tag" },
    { label: "Versão", key: "Versao" },
    { label: "Downloads", key: "NDownload" },
    { label: "Data de cadastro", key: "DTCadastro" },
    { label: "Classficação", key: "Classificacao" },
    { label: "Ativo?", key: "Ativo" }
    ];


    useLayoutEffect(() => {
        
    setBody(documentsAll.map(itens => {
        return {
        'TipoDoc': itens.TipoDoc === 1 ? 'Norma Técnica' : 'Desenho Padrão',
        'ID': itens.NRDocumento,
        'Titulo': itens.Titulo,
        'Descricao': itens.Descricao,
        'Ordem': itens.Ordem,
        'Tag': itens.Tag,
        'Versao': itens.Versao,
        'NDownload': itens.NDownload,
        'DTCadastro': new Date(itens.DTCadastro).toLocaleDateString(),
        'Classificacao': itens.Classificacao,
        'Ativo': itens.Ativo === true ? 'Sim' : 'Não'
      }
    }))
  },[documentsAll]);

    function organizarItens(data) {
        
    setBody(data.map(itens => {
        return {
        'TipoDoc': itens.TipoDoc === 1 ? 'Norma Técnica' : 'Desenho Padrão',
        'ID': itens.ID,
        'Titulo': itens.Titulo,
        'Descricao': itens.Descricao,
        'Ordem': itens.Ordem,
        'Tag': itens.Tag,
        'Versao': itens.Versao,
        'NDownload': itens.NDownload,
        'DTCadastro': new Date(itens.DTCadastro).toLocaleDateString(),
        'Classificacao': itens.Classificacao,
        'Ativo': itens.Ativo === true ? 'Sim' : 'Não'
      }
    }))
  }

    function handleDownloadExcel(docs) {
        organizarItens(docs);
    downloadExcel({
      fileName: "export-table-to-excel",
      sheet: "export-table-to-excel",
      tablePayload: {
        header,
        // accept two different data structures
        body: body
      },
    });

  }


    function gerarArquivo(type) {
        
        if (type.tipoDoc === 3) { handleDownloadExcel(documentsAll); setQuantidadeModal((state) => !state); }
    
  }


  return (
      <BaseModal
          isVisible={quantidadeModal}
          handleClose={() =>
              setQuantidadeModal((state) => !state)
          }
          className={`baseQuantity`}
      >
        <FormTitle>{`Gerar relatório`}</FormTitle>
        {/*<section className={`baseQuatityModal`}>*/}
        {/*  <h3>{`Período`}</h3>*/}
        {/*  <div className={`rangeDate`}>*/}
        {/*    <label htmlFor="Início">*/}
        {}
        {/*      <FormDatePicker  onChange={(e)=>changeData('start', e.target.value)}  value={moment(startDate).format('YYYY-MM-DD')}></FormDatePicker>*/}
        {/*    </label>*/}
        {/*  </div>*/}
        {/*  <div className={`rangeDate`}>*/}
        {/*    <label htmlFor="Fim">*/}
        {}
        {/*      <FormDatePicker onChange={(e)=>changeData('end', e.target.value)}  value={moment(endDate).format('YYYY-MM-DD')} ></FormDatePicker>*/}
        {/*    </label>*/}
        {/*  </div>*/}
        {/*</section>*/}
        <section className={`baseQuatityModal`}>
          <h3>{`Tipo`}</h3>
          <div className={`selectTypeDoc`}>
                  {tipoDocRelQuantity.map((newFilterQtd) => (
                <label key={newFilterQtd.id + newFilterQtd.text} htmlFor={newFilterQtd.id + newFilterQtd.text}
                       className="tipoDoc__item">
                  <input
                      type="radio"
                      name="tipoDocQtd"
                      checked={newFilterQtd.id === tipo.tipoDoc}
                      id={newFilterQtd.id + newFilterQtd.text}
                      onChange={() => {setTipo((prevState) => ({...prevState, tipoDoc: newFilterQtd.id}))}}
                  />
                  <span className="checkmark"></span>
                  {newFilterQtd.text}
                </label>
            ))}
          </div>
        </section>
        {
          tipo.tipoDoc === 3 ? (
              <Button className={`buttonQuantity`} onClick={() => gerarArquivo(tipo)}>
                {`Download`}
              </Button>

          ) : (
              <CSVLink
                  className={`buttonQuantity`}
                  data={body}
                  headers={headers}
                  target="_self"
                  separator={";"}
                  onClick={()=> {
                    if (startDate > endDate){
                      setResponseMsg({ isVisible: true, error: true, msg: `Data Fim menor que data Início` });
                      return;
                    }
                    setQuantidadeModal((state) => !state)}
                  }
                  filename={"export-table-to-csv.csv"}>
                {`Download`}
              </CSVLink>
          )
        }

      </BaseModal>
  );

};

export default QuantificationModal;
